import { workSheetConstants } from '../../_constants';

const initialState = { saveCommentLoading: true, data: '', error: false };

export function saveCommentReducer(state = initialState, action) {
    switch (action.type) {
        case workSheetConstants.REQUEST_SAVE_COMMENT:
            return {
                saveCommentLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_SAVE_COMMENT:
            return {
                saveCommentLoading: false,
                data: action.saveComment,
                error: false
            };
        case workSheetConstants.SAVE_COMMENT_ERROR:
            return {
                saveCommentLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/saveComment.reducer.js